import { Create } from "react-admin";

import SpecialityGroupForm from "./SpecialityGroupForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateSpecialityGroups = () => {
  return (
    <Create
      title="Създаване на група специалности"
      actions={<BackButtonToolbar />}
    >
      <SpecialityGroupForm />
    </Create>
  );
};
export default CreateSpecialityGroups;
